/* tslint:disable */
/* eslint-disable */
/**
 * Notifications API
 * An API to create and read notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: DevTeamProduct@digitalrealty.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime.js';
import type {
  ErrorResponse,
  GetNotifications200Response,
  Notification,
  NotificationBulkPatch,
  NotificationBulkPatchResult,
  NotificationDelete,
  NotificationPatch,
  NotificationRequest,
  Status,
} from '../models/index.js';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetNotifications200ResponseFromJSON,
    GetNotifications200ResponseToJSON,
    NotificationFromJSON,
    NotificationToJSON,
    NotificationBulkPatchFromJSON,
    NotificationBulkPatchToJSON,
    NotificationBulkPatchResultFromJSON,
    NotificationBulkPatchResultToJSON,
    NotificationDeleteFromJSON,
    NotificationDeleteToJSON,
    NotificationPatchFromJSON,
    NotificationPatchToJSON,
    NotificationRequestFromJSON,
    NotificationRequestToJSON,
    StatusFromJSON,
    StatusToJSON,
} from '../models/index.js';

export interface CreateNotificationRequest {
    notificationRequest?: NotificationRequest;
}

export interface DeleteNotificationsByIdRequest {
    id: string;
}

export interface GetNotificationsRequest {
    sort?: string;
    cursor?: string;
    resourceType?: string;
    accountNumber?: string;
    createdAfter?: Date;
    createdBefore?: Date;
    locationId?: string;
    subGroup?: string;
    status?: Status;
    prefer?: Array<string>;
}

export interface GetNotificationsByIdRequest {
    id: string;
}

export interface PatchNotificationsRequest {
    notificationBulkPatch: NotificationBulkPatch;
}

export interface PatchNotificationsByIdRequest {
    id: string;
    notificationPatch?: NotificationPatch;
}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     * Submit notification to be sent to user
     */
    async createNotificationRaw(requestParameters: CreateNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Notification>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerToken", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationRequestToJSON(requestParameters.notificationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Submit notification to be sent to user
     */
    async createNotification(requestParameters: CreateNotificationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Notification> {
        const response = await this.createNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a notification by id
     */
    async deleteNotificationsByIdRaw(requestParameters: DeleteNotificationsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationDelete>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteNotificationsById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerToken", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationDeleteFromJSON(jsonValue));
    }

    /**
     * Delete a notification by id
     */
    async deleteNotificationsById(requestParameters: DeleteNotificationsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationDelete> {
        const response = await this.deleteNotificationsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all notifications
     */
    async getNotificationsRaw(requestParameters: GetNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNotifications200Response>> {
        const queryParameters: any = {};

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.resourceType !== undefined) {
            queryParameters['resource_type'] = requestParameters.resourceType;
        }

        if (requestParameters.accountNumber !== undefined) {
            queryParameters['account_number'] = requestParameters.accountNumber;
        }

        if (requestParameters.createdAfter !== undefined) {
            queryParameters['created_after'] = (requestParameters.createdAfter as any).toISOString();
        }

        if (requestParameters.createdBefore !== undefined) {
            queryParameters['created_before'] = (requestParameters.createdBefore as any).toISOString();
        }

        if (requestParameters.locationId !== undefined) {
            queryParameters['location_id'] = requestParameters.locationId;
        }

        if (requestParameters.subGroup !== undefined) {
            queryParameters['sub_group'] = requestParameters.subGroup;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.prefer) {
            headerParameters['Prefer'] = requestParameters.prefer.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerToken", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNotifications200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all notifications
     */
    async getNotifications(requestParameters: GetNotificationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNotifications200Response> {
        const response = await this.getNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get an notification by id
     */
    async getNotificationsByIdRaw(requestParameters: GetNotificationsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Notification>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getNotificationsById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerToken", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Get an notification by id
     */
    async getNotificationsById(requestParameters: GetNotificationsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Notification> {
        const response = await this.getNotificationsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bulk update notifications for the authenticated user (by email and permitted account numbers)
     */
    async patchNotificationsRaw(requestParameters: PatchNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationBulkPatchResult>> {
        if (requestParameters.notificationBulkPatch === null || requestParameters.notificationBulkPatch === undefined) {
            throw new runtime.RequiredError('notificationBulkPatch','Required parameter requestParameters.notificationBulkPatch was null or undefined when calling patchNotifications.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerToken", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationBulkPatchToJSON(requestParameters.notificationBulkPatch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationBulkPatchResultFromJSON(jsonValue));
    }

    /**
     * Bulk update notifications for the authenticated user (by email and permitted account numbers)
     */
    async patchNotifications(requestParameters: PatchNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationBulkPatchResult> {
        const response = await this.patchNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update specific fields on a notification by id
     */
    async patchNotificationsByIdRaw(requestParameters: PatchNotificationsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationPatch>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchNotificationsById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerToken", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPatchToJSON(requestParameters.notificationPatch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationPatchFromJSON(jsonValue));
    }

    /**
     * Update specific fields on a notification by id
     */
    async patchNotificationsById(requestParameters: PatchNotificationsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationPatch> {
        const response = await this.patchNotificationsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
